import { fetchPackages } from "modules/membership_plan/commercial_membership_plan/packages/store/action";
import { connect } from "react-redux";
import { SetVideoToAnotherGroupError, SetVideoToAnotherGroupInput } from "../../store/actionType";
import { useEffect } from "react";
import { CancelButton, Error, InputForm, SelectForm, SubmitButton } from "components";
import { fetchVideoGroups } from "modules/video/group/store/action";
import { fetchVideoEpisodes } from "modules/video/episode/store/action";
import { GenericProps } from "modules/user_management/dcdd_user/users/state/actionType";
import { fetchVideoCategories } from "modules/video/category/store/action";
import { fetchVideoSeason } from "modules/video/season/store/action";
import { fetchVideoSeries } from "modules/video/series/store/action";
interface FormProps {
    loading: boolean;
    header: string;
    formData: SetVideoToAnotherGroupInput;
    error: SetVideoToAnotherGroupError;
    handleChange?: (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) => void;
    handleSubmit?: React.MouseEventHandler<HTMLButtonElement>;
    onClose: () => void;
}
type DispatchProps = ReturnType<typeof mapDispatchToProps>;
type StateProps = ReturnType<typeof mapStateToProps>;
type Props = DispatchProps & StateProps & FormProps;
const SetVideoForm: React.FC<Props> = ({
    onFetchPackages,
    onFetchVideoGroups,
    onFetchVideoEpisodes,
    onFetchVideoCategories,
    videoGroupState,
    videoCategoriesState,
    videoSeriesState,
    videoEpisodesState,
    videoSeasonsState,
    onFetchVideoSeason,
    onFetchVideoSeries,
    fetchPackages,
    loading,
    header,
    formData,
    handleChange,
    handleSubmit,
    error,
    onClose,
}) => {
    useEffect(() => {
        onFetchVideoGroups();
    }, [onFetchVideoGroups]);

    useEffect(() => {
        onFetchVideoCategories(formData.group_id || "");
    }, [formData.group_id, onFetchVideoCategories])

    useEffect(() => {
        onFetchVideoSeries(formData.category_id || "");
    }, [formData.category_id, onFetchVideoSeries])



    useEffect(() => {
        onFetchVideoSeason(formData.series_id || "");
    }, [formData.series_id, onFetchVideoSeason])


    useEffect(() => {
        onFetchVideoEpisodes(formData.season_id || "");
    }, [formData.season_id, onFetchVideoEpisodes])


   const onChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) => {
    const { name, value } = e.target;
    if (name === "season_id") {
        const selectedSeason = videoSeasonsState?.video_seasons?.find(
            (season: any) => season.id?.toString() === value
        );
        handleChange?.(e);
        if (selectedSeason) {
            handleChange?.({
                target: {
                    name: "folder_id",
                    value: selectedSeason.folder_id || "",
                }
            } as any);
        }

        return;
    }
    handleChange?.(e);
};
    const onSubmit = (e: React.MouseEvent<HTMLButtonElement>) => {
        e.preventDefault();
        if (handleSubmit) {
            handleSubmit(e);
        }
        onClose();
    };
    return (
        <div>
            <form>
                <h2 className="text-xl font-bold my-3">{header}</h2>
                <div>
                    <SelectForm
                        type="text"
                        styleLabel="text-sm/6 font-medium after:content-['*'] after:ml-1 after:text-red-500"
                        label="Video Group"
                        id="group_id"
                        name="group_id"
                        value={formData.group_id || ""}
                        option={videoGroupState?.groups?.map((group: GenericProps) => (
                            <option
                                key={group.id.toString()}
                                value={group.id.toString()}
                            >
                                {group.name}
                            </option>
                        ))}
                        onChange={onChange}
                    />
                    {error.group_id && <Error>{error.group_id}</Error>}
                </div>
                <div>
                    <SelectForm
                        type="text"
                        styleLabel="text-sm/6 font-medium after:content-['*'] after:ml-1 after:text-red-500"
                        label="Category"
                        id="category_id"
                        name="category_id"
                        value={formData.category_id || ""}
                        option={videoCategoriesState?.categories?.map((category: GenericProps) => (
                            <option
                                key={category.id.toString()}
                                value={category.id.toString()}
                            >
                                {category.name}
                            </option>
                        ))}
                        onChange={onChange}
                    />
                    {error.category_id && <Error>{error.category_id}</Error>}
                </div>
                <div>
                    <SelectForm
                        type="text"
                        styleLabel="text-sm/6 font-medium after:content-['*'] after:ml-1 after:text-red-500"
                        label="Series"
                        id="series_id"
                        name="series_id"
                        value={formData.series_id || ""}
                        option={videoSeriesState?.video_series?.map((series: any) => (
                            <option
                                key={series.id?.toString()}
                                value={series.id?.toString()}
                            >
                                {series.title}
                            </option>
                        ))}
                        onChange={onChange}
                    />
                    {error.series_id && <Error>{error.series_id}</Error>}
                </div>
                <div>
                    <SelectForm
                        type="text"
                        styleLabel="text-sm/6 font-medium after:content-['*'] after:ml-1 after:text-red-500"
                        label="Season"
                        id="season_id"
                        name="season_id"
                        value={formData.season_id || ""}
                        option={videoSeasonsState?.video_seasons?.map((season: any) => (
                            <option
                                key={season.id?.toString()}
                                value={season.id?.toString()}
                            >
                                {season.title}
                            </option>
                        ))}
                        onChange={onChange}
                    />
                    {error.season_id && <Error>{error.season_id}</Error>}
                </div>
                <div>
                    <SelectForm
                        type="text"
                        styleLabel="text-sm/6 font-medium after:content-['*'] after:ml-1 after:text-red-500"
                        label="Episode"
                        id="episode_id"
                        name="episode_id"
                        value={formData.episode_id || ""}
                        option={videoEpisodesState?.video_episode?.map((episode: any) => (
                            <option
                                key={episode.id?.toString()}
                                value={episode.id?.toString()}
                            >
                                {episode.label}
                            </option>
                        ))}
                        onChange={onChange}
                    />
                    {error.episode_id && <Error>{error.episode_id}</Error>}
                </div>
                <div>
                    <InputForm
                        type="text"
                        styleLabel="text-sm/6 font-medium after:content-['*'] after:ml-1 after:text-red-500"
                        label="Title"
                        id="title"
                        name="title"
                        value={formData.title}
                        onChange={onChange}
                    />
                    {error.title && <Error>{error.title}</Error>}
                </div>
                <div className="mt-4 w-full flex justify-between">
                    <CancelButton onClick={onClose} />
                    <SubmitButton loading={loading} onClick={onSubmit} />
                </div>
            </form>
        </div>
    );
};
const mapStateToProps = (state: any) => ({
    fetchPackages: state.packages.fetchPackagesState,
    videoGroupState: state.videoGroups.videoGroupsState,
    videoEpisodesState: state.videoEpisodes.videoEpisodeState,
    videoCategoriesState: state.videoCategories.videoCategoriesState,
    videoSeasonsState: state.videoSeasons.videoSeasonsState,
    videoSeriesState: state.videoSeries.videoSeriesState,
});

const mapDispatchToProps = (dispatch: any) => ({
    onFetchPackages: () => dispatch(fetchPackages()),
    onFetchVideoGroups: () => dispatch(fetchVideoGroups()),
    onFetchVideoEpisodes: (season_id: string) =>
        dispatch(fetchVideoEpisodes(season_id)),
    onFetchVideoCategories: (group_id: string) =>
        dispatch(fetchVideoCategories(group_id)),
    onFetchVideoSeason: (series_id: string) =>
        dispatch(fetchVideoSeason(series_id)),
    onFetchVideoSeries: (category_id: string) =>
        dispatch(fetchVideoSeries(category_id)),
});

export default connect(mapStateToProps, mapDispatchToProps)(SetVideoForm);
